import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=50023f04&lang=pug&"
import script from "./Roulette.vue?vue&type=script&lang=js&"
export * from "./Roulette.vue?vue&type=script&lang=js&"
import style0 from "./Roulette.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports